"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.active = exports.content = exports.wrapper = exports.pageHover = void 0;

var react_1 = require("@emotion/react");

exports.pageHover = react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &:hover {\n    border: 2px solid var(--blue-400);\n  }\n"])));

var wrapper = function wrapper(isArrow) {
  return react_1.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 40px;\n  height: 40px;\n  background-color: white;\n  border: 0;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--blue-400);\n  transition: color 0.4s var(--motion-easing-basic),\n    background 0.4s var(--motion-easing-basic);\n\n  ", "\n"])), !isArrow && exports.pageHover);
};

exports.wrapper = wrapper;
exports.content = react_1.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 500;\n  width: 14px;\n  height: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
exports.active = react_1.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  background-color: var(--blue-400);\n  color: var(--white);\n"])));